document.addEventListener("DOMContentLoaded", () => {

  /* ----------------------------
     COUNTDOWN
  ----------------------------- */
  const section = document.querySelector(".covenant-password-section");
  const dateString = section.dataset.countdown;

  const d = document.getElementById("cd-days");
  const h = document.getElementById("cd-hours");
  const m = document.getElementById("cd-mins");
  const s = document.getElementById("cd-secs");

  const target = new Date(dateString).getTime();

  function tick() {
    const now = Date.now();
    const diff = target - now;

    if (diff <= 0) {
      d.textContent = h.textContent = m.textContent = s.textContent = "00";
      return;
    }

    d.textContent = String(Math.floor(diff / 86400000)).padStart(2, "0");
    h.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, "0");
    m.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, "0");
    s.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, "0");
  }

  tick();
  setInterval(tick, 1000);


  /* ----------------------------
     SUBSCRIBE FIX (evita redirects raros)
  ----------------------------- */
  const form = document.querySelector(".covenant-subscribe-form");

  if (form) {
    form.addEventListener("submit", () => {
      form.action = "/contact#password-subscribe";
    });
  }

});
